// src/api/clinicApi.js
import drEasyApi from "../Api/Customapi";

export const fetchClinics = async (pageNumber = 1, pageSize = 10) => {
  try {
    const response = await drEasyApi.get(
      `/api/Clinic/my-clinics?PageNumber=${pageNumber}&PageSize=${pageSize}`
    );
    return response.data.data;
  }
  catch (err) {
    if (err.response.status == 403) {
      // window.location.href = "/sub"; // Adjust auth path as needed

    }
  } 
};

export const addClinic = async (clinicData) => {
  const response = await drEasyApi.post("/api/Clinic/AddClinic", clinicData);
  return response.data;
};

export const updateClinic = async (clinicData) => {
  const response = await drEasyApi.put("/api/Clinic/UpdateClinic", clinicData);
  return response.data;
};

export const deleteClinic = async (id) => {
  const response = await drEasyApi.delete(`/api/Clinic/DeleteClinic/${id}`);
  return response.data;
};
